<template lang="pug">
  el-badge(:value="points" :type="type")
    slot
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },

    type: {
      type: String,
      default: "success"
    }
  },

  computed: {
    points() {
      if (this.value >= 1) {
        return `${this.value} pt${this.value > 1 ? "s" : ""}`;
      }
      return "✔";
    }
  }
};
</script>

<style>
.el-badge {
  margin-top: 5px;
}

.el-badge__content.is-fixed {
  right: 25px;
  padding: 1px 10px 1px 10px;
}
</style>
